import { useContext, useState, useEffect } from "react";
import { ModalContext } from "../../../utils/modal/ModalProvider";
import { DialogEnum, showDialog } from "../../../utils/dialog/Dialog";
import { IAM_PATH, IAM_SERVER_SERVICE_LICENSE } from "../../../utils/Config";
import Loading from "../../../utils/loading/Loading";
import axios from "../../../utils/api/axios";
import styles from "../../../utils/modal/DetailModal.module.css";
import { format } from "date-fns";
import { containsXss } from "../../../utils/security/XssFilter";
import AES, { encrypt } from "../../../utils/crypto/AES";

export const PlanRegisterModal = ({ update, selectedServiceId, productId, productName }) => {
    const { closeModal } = useContext(ModalContext);
    const [loading, setLoading] = useState(true);
    const [serviceUserList, setServiceUserList] = useState([]);   // 전체 서비스 유저 [{userId, name}]
    const [groupUserList, setGroupUserList] = useState([]);       // 현재 그룹 유저 [{userId}]
    const [availableUsers, setAvailableUsers] = useState([]);     // 그룹에 미포함된 유저 [{userId, name}]
    const [assignedUsers, setAssignedUsers] = useState([]);       // 그룹에 포함된 유저 [{userId, name}]
    const [selectedAvailable, setSelectedAvailable] = useState([]);
    const [selectedAssigned, setSelectedAssigned] = useState([]);

    const today = new Date().toISOString().split('T')[0];
    const futureDate = new Date(today);
    futureDate.setMonth(futureDate.getMonth() + 1);

    const onemonth = futureDate.toISOString().split('T')[0];

    const [startDate, setStartDate] = useState(today);
    const [endDate, setEndDate] = useState(onemonth);
    const [status, setStatus] = useState("deactive");
    const [isNull, setIsNull] = useState(false); //빈 값 확인

    const [formData, setFormData] = useState({
        productId: productId,
        plan: '',
        cost: '',
        // detail: ''
    });

    // const [today] = useState({});


    useEffect(() => {
        setLoading(true);
        setLoading(false);
    }, []);

    // 왼쪽 → 오른쪽 (그룹에 추가)
    const handleAssign = () => {
        const toAssign = availableUsers.filter(user =>
            selectedAvailable.includes(user.userId)
        );
        setAssignedUsers([...assignedUsers, ...toAssign]);
        setAvailableUsers(availableUsers.filter(user =>
            !selectedAvailable.includes(user.userId)
        ));
        setSelectedAvailable([]);
    };

    // 오른쪽 → 왼쪽 (그룹에서 제거)
    const handleUnassign = () => {
        const toUnassign = assignedUsers.filter(user =>
            selectedAssigned.includes(user.userId)
        );
        setAvailableUsers([...availableUsers, ...toUnassign]);
        setAssignedUsers(assignedUsers.filter(user =>
            !selectedAssigned.includes(user.userId)
        ));
        setSelectedAssigned([]);
    };

    // 체크박스 핸들러
    const handleCheckbox = (id, fromList) => {
        const setter = fromList === 'assigned' ? setSelectedAssigned : setSelectedAvailable;
        const current = fromList === 'assigned' ? selectedAssigned : selectedAvailable;
        setter(current.includes(id)
            ? current.filter(i => i !== id)
            : [...current, id]
        );
    };

    // 저장 로직
    const handleSave = () => {
        for (let key in formData) {
            const value = formData[key];
            if (value === '') {
                setIsNull(true);
                showDialog(DialogEnum.DEFAULT, "경고", "올바른 값을 입력해 주세요.");
                return;
            } else if (typeof value === 'string' && containsXss(value)) {
                setFormData((prevState) => ({
                    ...prevState,
                    [key]: ''
                }));
                setIsNull(true);
                showDialog(DialogEnum.DEFAULT, "경고", "올바른 값을 입력해 주세요.");
                return;
            }
        }
        setIsNull(false);

        const params = {
            productId: productId,
            plan: formData.plan,
            cost: formData.cost,
            // detail : formData.detail
        };

        const url = IAM_PATH + IAM_SERVER_SERVICE_LICENSE + "/create";
        axios.post(url, params)
            .then((res) => {
                if (res.data.code == 200) {
                    showDialog(DialogEnum.SUCCESS, "성공", res.data.message, closeModal);
                    update();
                } else {
                    showDialog(DialogEnum.DEFAULT, "실패", res.data.message);
                }
            })
            .catch((e) => {
                showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
                console.error(e);
            });
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    }

    const handleStartDateChange = (e) => {
        setStartDate(e.target.value);
        formData.startDate = e.target.value;
    };

    const handleEndDateChange = (e) => {
        if (formData.startDate > e.target.value) {
            alert("종료일은 시작일보다 뒤 날짜를 선택해야 합니다.");
        } else {
            setEndDate(e.target.value);
            formData.endDate = e.target.value;
        }
    };

    const handleStatusChange = (e) => {
        setStatus(e.target.value);
        formData.status = e.target.value;
    };

    return (
        <div style={{ overflow: "auto" }}>
            {loading ? <Loading /> :
                <div>
                    <ul className={styles.layer__listWrap}>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>제품명</p>

                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"product"}
                                value={productName}
                                readOnly
                                onChange={handleChange}
                            />
                        </li>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>요금제</p>

                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"plan"}
                                value={formData.plan}
                                onChange={handleChange}
                            />
                        </li>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>가격</p>

                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"cost"}
                                value={formData.cost}
                                onChange={handleChange}
                            />
                        </li>
                        {/* <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>비고</p>
                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"detail"}
                                value={formData.detail}
                                onChange={handleChange}
                                />
                        </li> */}
                    </ul>

                    {/* {isNull ? <div className={`${styles.layer__text} ${styles.warning}`}>빈 칸을 확인해 주세요.</div> : null} */}
                    <div className={styles.layer__sensorBtnBox}>
                        {/* <button className={styles.layer__deleteBtn} onClick={"handleDelete"}>삭제</button> */}
                        <button className={styles.layer__modifyBtn} onClick={handleSave}>등록</button>
                    </div>
                </div>
            }
        </div>
    );
};
